import { t } from "i18next";

/** Axios-style error carrying a server message in its response body. */

/**
 * Derives a human-readable message from a failed decision-select request,
 * preferring the backend-provided message and falling back to a generic string.
 */
export function getDecisionErrorMessage(error) {
  var _response$data$messag, _response;
  var rawMessage = (_response$data$messag = error === null || error === void 0 || (_response = error.response) === null || _response === void 0 || (_response = _response.data) === null || _response === void 0 ? void 0 : _response.message) !== null && _response$data$messag !== void 0 ? _response$data$messag : "";
  if (rawMessage) return rawMessage;
  return t("error.select_decision_failed", {
    defaultValue: "Couldn't apply the decision. Please try again."
  });
}